import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../i18n';

const KeywordsInput = (props) => {
    const { t } = useTranslation();
    const { keywords, handleChangeOnKeywords } = props


    return (
        <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
            <input
                value={keywords}
                className="block w-full border border-gray-300 rounded py-3 px-4"
                name="keywords"
                type="text"
                placeholder={t('keywords')}
                style={{ height: '38px' }}
                onChange={handleChangeOnKeywords}
            />
        </div>
    )
}

export default KeywordsInput;